const index = {
  state: {
    isTabIndex:0,
  },
  mutations: {
    SetTabIndex(state,data){
      state.isTabIndex = data
    }
  },
  actions: {
    setTabIndex(state,data){
      state.isTabIndex = data
    }
  },
  getters: {
    // permissions: state => state.permissions,
    // permission_routes: state => state.permission_routes
  }
};
export default index;



// WEBPACK FOOTER //
// ./src/store/modules/index.js